import React, { useEffect, useState } from "react";
import { Star, MapPin } from "lucide-react";
import { useLang } from "../i18n/LanguageContext";
import api from "../lib/api";

const Stars = ({ n, size = "w-5 h-5" }) => (
  <div className="flex gap-0.5">
    {[1, 2, 3, 4, 5].map((i) => (
      <Star key={i} className={`${size} ${i <= n ? "fill-amber-400 text-amber-400" : "text-slate-300"}`} />
    ))}
  </div>
);

const Reviews = () => {
  const { tr } = useLang();
  const [data, setData] = useState({ reviews: [], average: 0, count: 0 });
  useEffect(() => { api.get("/reviews").then((r) => setData(r.data)); }, []);
  if (!data.count) return null;

  return (
    <section className="py-16 md:py-24 bg-white" data-testid="reviews-section">
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-4 mb-12">
          <div>
            <h2 className="font-heading font-bold text-3xl md:text-4xl text-ink tracking-tight">{tr.reviews.title}</h2>
            <div className="flex items-center gap-3 mt-3">
              <Stars n={Math.round(data.average)} size="w-6 h-6" />
              <span className="font-heading font-extrabold text-2xl text-ink">{data.average}</span>
              <span className="text-ink-muted text-lg">· {data.count} {tr.reviews.based}</span>
            </div>
          </div>
        </div>
        <div className="grid gap-6 md:grid-cols-3">
          {data.reviews.slice(0, 6).map((r) => (
            <div key={r.id} className="bg-cream rounded-3xl p-6 border border-slate-100">
              <Stars n={r.rating} />
              <p className="text-lg text-ink leading-relaxed my-4">“{r.comment}”</p>
              <div className="flex items-center justify-between text-sm text-ink-muted font-semibold">
                <span>{r.author}</span>
                <span className="flex items-center gap-1"><MapPin className="w-4 h-4" /> {tr.reviews.in} {r.city}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export { Stars };
export default Reviews;
